import { Card, CardContent } from '@mui/material';
import { FC } from 'react';

interface Props {
  children: React.ReactNode;
}

export const AssetFormActionsContainer: FC<Props> = ({ children }) => {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '24px', paddingTop: '24px' }}>
      <Card>
        <CardContent sx={{ justifyContent: 'space-between', display: 'flex', paddingBottom: '16px !important' }}>{children}</CardContent>
      </Card>
    </div>
  );
};
